<template>
  <el-dialog :close-on-click-modal="false"  
    title="汇率设置"
    :visible.sync="visible"
    width="400px"
    class="exchangeDialog"
    :before-close="handleClose"
    
  > 
    <el-table :data="exchangeData" class="exchange-table"> 
      <el-table-column prop="currency" label="币别">
        <template slot-scope="scope">
          {{ dictMap['currency'][scope.row.currency] }}
        </template>
      </el-table-column>
      <el-table-column prop="defaultRate" label="默认汇率"> 
        <template slot-scope="scope">
          1：{{ scope.row.defaultRate }}
        </template>
      </el-table-column>
      <el-table-column prop="rate" label="汇率">
        <template slot-scope="scope">
          <div style="display: flex;align-items: center;">
            1：
            <el-input
              v-model="scope.row.rate"
              class="input"
              size="small"
              style="width: 90px;"
              type="number"
            />
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="tip">
      <span class="store-info-icon">说明！</span>
      未填写汇率时，系统将使用默认汇率计算。
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose" size="small">返回</el-button>
      <el-button type="primary" @click="sure" size="small">
        确定
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { listCurrencyFee, addCurrencyFee } from '@/api/order/all'
import { mapGetters } from "vuex"

export default {
  name: "ExchangeDialog",
  data() {
    return {
      exchangeData: [],
    };
  },
  props: {
    visible: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  computed: {
    ...mapGetters(["dictData", "dictMap"]),
  },
  watch: {
    visible() {
      this.getData();
    }
  },
  methods: {
    getData() {
      listCurrencyFee().then(res => {
        this.exchangeData = res.data
      })
    },
    sure() {
      // for(let record of this.exchangeData){
      //   if(record.rate.toString().trim() == ""){
      //     this.$message.error("汇率不能为空")
      //     return
      //   }
      // }
      addCurrencyFee(this.exchangeData).then(res => {
        if (res.code !== 200) {
          this.$message.error("修改失败")
        } else {
          this.$message.success("修改成功")
          this.$emit("onOk");
        }
      })
    },
    handleClose() {
      this.$emit("onClose");
    },
  },
};
</script>

<style scoped>
.exchangeDialog {
  font-size: 12px;
}
.tip {
  margin-top: 10px;
  font-size: 12px;
}
.tip .store-info-icon {
  display: inline-block;
  padding: 0 0 0 5px;
  background: #129ba7;
  color: #fff;
  border-radius: 2px;
  margin-right: 5px;
  line-height: 1.4;
}
</style>
